import { render, staticRenderFns } from "./PriceMapForm.vue?vue&type=template&id=931885e8"
import script from "./PriceMapForm.vue?vue&type=script&lang=js"
export * from "./PriceMapForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports